import ky from 'ky';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import { USERS_PER_PAGE } from 'src/utils/api/list-users/constant';
import { listUsersSchema } from './types-and-schema';
import { paginateUsers } from './paginate-users';
import { getSearchAutoComplete } from './getSearchAutoComplete';

export interface ListUsersPromiseParams {
  pageNumber?: string | number;
  search?: string;
}

export const listUsersPromise = async ({ pageNumber, search }: ListUsersPromiseParams) => {
  try {
    const headers = getHeadersWithBearerToken();

    const searchParams = new URLSearchParams();
    searchParams.set('page_size', USERS_PER_PAGE.toString());
    searchParams.set('page_num', pageNumber?.toString() || '1');
    searchParams.set('search_term', search || '');

    const searchParamsString = searchParams.toString();

    const response = await ky
      .get(`${ENV.API_URL}/external-user-management/get-all-users/?${searchParamsString}`, {
        headers,
      })
      .json();

    const result = listUsersSchema.safeParse(response);

    if (!result.success) {
      throw new Error(result.error.message);
    }

    const data = result.data?.data.map((user) => ({
      ...(user || {}),
      id: user.uuid,
    }));

    return {
      paginatedData: paginateUsers(data),
      autoCompleteData: getSearchAutoComplete(data),
      totalUsers: result.data?.metadata?.total_users || 0,
      total_pages: result?.data?.metadata?.total_pages || 1,
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      paginatedData: {
        users: [],
        totalPages: 0,
      },
      autoCompleteData: [],
      totalUsers: 0,
      total_pages: 0,
    };
  }
};

export type ListUsersData = Awaited<ReturnType<typeof listUsersPromise>>;
export type ListUserItem = ListUsersData['paginatedData']['users'][0][0];
